import SupervisorContainer from './SupervisorContainer';
export default SupervisorContainer;